import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { CoilSheetDataSets } from '../entities/coilSheet';
import { EnvironmentConfigService } from './environment-config.service';

@Injectable({
  providedIn: 'root'
})
export class ExportService {

  exportApiUrl: string = `${EnvironmentConfigService.getApiGatewayConfig().EXPORT_ENDPOINT}/export`;

  constructor(private http: HttpClient) { }

  exportCoilSheet(coilSheetDataSets: CoilSheetDataSets[], exportFormat: string, dataExportChartType: string, measurementUnit: string) {
    const params = new HttpParams().set('measurementSystem', measurementUnit);
    return this.http.post(`${this.exportApiUrl}/${exportFormat}/${dataExportChartType}`, coilSheetDataSets, {
      params: params, responseType: 'blob'});
  }

  public downloadFile(data: any, fileName: string) {
    let downloadLink = document.createElement('a');
    downloadLink.href = window.URL.createObjectURL(new Blob([data], { type: data.type }));
    downloadLink.setAttribute('download', fileName);
    document.body.appendChild(downloadLink);
    downloadLink.click();
  }
}
